export namespace ActionTranslations {
  export const common = {
    copiedToClipboard: 'copiedToClipboard',
  } as const;
}
